import { Controller } from "@hotwired/stimulus"
import { lockScroll, unlockScroll } from "../lib/scroll_lock"

// Reject Modal Controller
// Triggers modal by global ID from any location on the page
//
// Usage (on trigger button - can be anywhere on page):
//   data-controller="reject-modal"
//   data-reject-modal-target-value="reject-modal"
//   data-action="click->reject-modal#open"
//
// Usage (on modal element - for close/backdrop actions):
//   id="reject-modal"
//   data-controller="reject-modal"
//   data-action="click->reject-modal#closeOnBackdrop"
export default class extends Controller {
  static values = {
    target: { type: String, default: "reject-modal" }
  }

  connect() {
    // Listen for Escape key globally
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
    document.addEventListener('keydown', this.boundCloseOnEscape)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundCloseOnEscape)
  }

  // Get modal element by ID (works from any location on page)
  get modal() {
    return document.getElementById(this.targetValue)
  }

  // Open modal
  open(event) {
    event?.preventDefault()
    if (this.modal) {
      this.modal.classList.remove('hidden')
      lockScroll(this)
    }
  }

  // Close modal
  close(event) {
    event?.preventDefault()
    if (this.modal) {
      this.modal.classList.add('hidden')
      unlockScroll(this)
    }
  }

  // Close on backdrop click
  closeOnBackdrop(event) {
    if (event.target === this.modal) {
      this.close(event)
    }
  }

  // Close on Escape key
  closeOnEscape(event) {
    if (event.key === 'Escape' && this.modal && !this.modal.classList.contains('hidden')) {
      this.close(event)
    }
  }
}
